import {
  isOtherTextRequired,
  shouldClearOtherField,
  type ConditionalOtherConfig,
} from "@porchpass/ui";
import { test } from "src/utils";

/** Include *_other in API payload only when parent enum is in the config trigger set. */
export function otherTextForApi(
  parent: string | undefined,
  other: string | undefined | null,
  config: Pick<ConditionalOtherConfig<unknown>, "triggerValues">,
): string | undefined {
  if (!parent || shouldClearOtherField(parent, config)) {
    return undefined;
  }
  return other ?? undefined;
}

export function testOtherTextRequired<TCtx>(
  parent: string | undefined,
  config: ConditionalOtherConfig<TCtx>,
  ctx: TCtx,
  message: string,
) {
  return test(
    (otherText) =>
      !isOtherTextRequired(parent, otherText as string, config, ctx),
    message,
  );
}
